var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMyFavorite = function SvgMyFavorite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "my favorite",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z",
    "data-name": "Rectangle 5339"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5903"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0e2240",
    d: "M12.002 1a1.57 1.57 0 0 1 1.409.877l2.855 5.788 6.387.928a1.57 1.57 0 0 1 1.042.625 1.55 1.55 0 0 1 .288 1.162 1.6 1.6 0 0 1-.456.9l-4.622 4.507 1.092 6.362a1.573 1.573 0 0 1-2.286 1.657l-5.71-3-5.713 3a1.573 1.573 0 0 1-2.283-1.66l1.092-6.36-4.621-4.505a1.573 1.573 0 0 1 .873-2.685l6.385-.928 2.855-5.788A1.57 1.57 0 0 1 12.002 1m6.441 21.541h.022a.13.13 0 0 0 .108-.149l-1.22-7.11 5.164-5.035a.13.13 0 0 0 .037-.073v-.008a.12.12 0 0 0-.022-.09.13.13 0 0 0-.09-.053l-7.136-1.037-3.191-6.469a.13.13 0 0 0-.058-.058.1.1 0 0 0-.057-.014.14.14 0 0 0-.121.075L8.69 8.985l-7.138 1.037a.13.13 0 0 0-.071.224l5.165 5.034-1.22 7.11a.13.13 0 0 0 .011.08.13.13 0 0 0 .118.073.1.1 0 0 0 .057-.014L12 19.171l6.385 3.357a.1.1 0 0 0 .058.013",
    "data-name": "Path 5045"
  }))));
};
export default SvgMyFavorite;